import { getBillingLocation, retrieveAccountAction } from './actions';
import { billingInfoSelector, recurlyInstanceSelector } from './selectors';

export const ensureAccountPresent = () => (dispatch, getState) => {
  const billingInfo = billingInfoSelector(getState());
  if (billingInfo?.paymentMethod) {
    return Promise.resolve(billingInfo);
  }

  return dispatch(retrieveAccountAction())
    .then(() => billingInfoSelector(getState()));
};

export const ensureRecurlyInstance = () => (dispatch, getState) => {
  const recurlyInstance = recurlyInstanceSelector(getState());
  if (recurlyInstance) {
    return Promise.resolve(recurlyInstance);
  }

  return dispatch(getBillingLocation())
    .then(() => recurlyInstanceSelector(getState()));
};
